export enum ApiMediaFormat {
  BlobUrl,
  Progressive,
  DownloadUrl,
  Text,
}

export type ApiParsedMedia = string | Blob | ArrayBuffer;
export type ApiPreparedMedia = string;
